import React from 'react'
const FormContext = React.createContext({
  direction: 'forward',
  setDirection: (direction) => {},
})
export default FormContext